import Vue from 'vue'
import HomeRouter from './router/home-router'
import NewRouter from './router/news-router'



export default [
  ...HomeRouter,
  ...NewRouter,
]

